import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {toSnakeCase, withValues} from 'utils/object';
import {request} from 'utils/request-axios';

import {EditTeamMemberFormFields} from './types';

type PossibleResponses = Api.Response.SuccessAxios;

const useEditTeamMember = (): UseMutationResult<
    PossibleResponses,
    Error,
    {formData: EditTeamMemberFormFields; mid: string}
> => {
    const locale = useLocale();

    return useMutation({
        mutationFn: ({formData, mid}) =>
            request({
                formData: toSnakeCase(withValues(formData)),
                locale,
                method: 'POST',
                url: `/ui/team/${mid}/edit/`,
            }),
    });
};

export default useEditTeamMember;
